export enum DocumentType {
  Course = 'Course',
  Bundle = 'Bundle',
  Topic = 'Topic',
  Question = 'Question',
  Chapter = 'Chapter',
}

export enum Action {
  Publish = 'publish',
  Unpublish = 'unpublish',
  QuickSend = 'quickSend',
}

export interface Item {
  document_type: DocumentType;
  errors: string[];
  warnings: string[];
  name: string;
  topic_name: string;
}
